export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-ACTUAL-01.d166ad11.jpg";